import React, { useState, MouseEventHandler } from "react"
import { isMobile } from "react-device-detect"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import { Colors } from "Const"
import styles from "./RightArrowButton.module.scss"

export interface Props {
  color: string
  arrowColor: string
  text: string
  text2?: string
  onClick: MouseEventHandler
  isSquareOnPC: boolean
}
/**
 * 左矢印付きボタン
 * @param {string} color - ボタンの色
 * @param {string} arrowColor - 矢印の色
 * @param {string} text - ボタン上に表示する文言①
 * @param {string} text - ボタン上に表示する文言②
 * @param {MouseEventHandler} onClick - ボタン押下時の処理
 * @param {boolean} isSquareOnPC - PCの場合にボタンを四角形にする場合、この項目を設定
 */
const Button = ({ color, arrowColor, text, text2 = "", onClick, isSquareOnPC = false }: Props) => {
  const [isTap, setIsTap] = useState(false)
  const tapOrHover = `${isMobile ? "" : styles.hover} ${isTap ? styles.onTap : ""}`
  return (
    <div
      className={`${styles.button} ${isSquareOnPC ? styles.button_pc : ""} ${tapOrHover}`}
      style={{
        backgroundColor: color,
        border: `${arrowColor === Colors.White ? "none" : "3px solid"}`,
        borderColor: arrowColor
      }}
      onClick={onClick}
      onTouchStart={() => {
        setIsTap(true)
      }}
      onTouchEnd={() => {
        setIsTap(false)
      }}
      aria-hidden="true"
    >
      <span
        className={`${text2 ? styles.button__text2 : styles.button__text} 
        ${isSquareOnPC ? styles.button_pc__text_pc : ""}`}
        style={{ color: arrowColor }}
      >
        {text}
        {text2 && (
          <>
            <br />
            {text2}
          </>
        )}
      </span>
      <ArrowForwardIcon style={{ color: arrowColor }} />
    </div>
  )
}

export default Button
